import { render, staticRenderFns } from "./ClientPhoto.vue?vue&type=template&id=7e711260"
import script from "./ClientPhoto.vue?vue&type=script&lang=ts"
export * from "./ClientPhoto.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports